// Simple admin auth helpers (localStorage-based Bearer token).
import axios from "axios";

const KEY = "aktra_admin_token";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getToken() {
  return localStorage.getItem(KEY);
}
export function setToken(token) {
  localStorage.setItem(KEY, token);
}
export function clearToken() {
  localStorage.removeItem(KEY);
}
export function authHeaders() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export async function apiGet(path) {
  const { data } = await axios.get(`${API}${path}`, { headers: authHeaders() });
  return data;
}

export async function apiPost(path, body) {
  const { data } = await axios.post(`${API}${path}`, body, { headers: authHeaders() });
  return data;
}

export async function apiPatch(path, body) {
  const { data } = await axios.patch(`${API}${path}`, body, { headers: authHeaders() });
  return data;
}
